<template>
  <section id="section1">
    <div class="row">
      <div class="column">
        <h3>{{ content['0.titel'] }}</h3>
        <p>{{ content['0.uitleg'] }}</p>
      </div>
      <div class="column">
        <Sponsors />
      </div>
    </div>
  </section>
</template>

<script>
import content from '@/content/website.json'
import Sponsors from './Sponsors'

export default {
  name: 'Section1',
  components: {
    Sponsors
  },
  data () {
    return {
      content
    }
  }
}
</script>

<style scoped lang="scss">
#section1 {
  padding: 6rem 9rem;
  max-width: 120rem;
  margin: 0 auto;

  h3 {
    color: $color-orange;
  }

  .sponsors {
    padding-top: 3rem;
  }
}
</style>
